import { colors } from '@ui/colors'

import { OvalState } from './types'

/** Visible band widths in screen pixels, measured outward from the oval edge. */
export const OUTLINE_INNER_WIDTH = 4
export const OUTLINE_INNER_COLOR = colors.neutral[700]

/** Total outer band width from the oval edge (the inner 8px are covered by the gray outline). */

export const MASK_GRADIENT_OPACITY_TOP = 0.9
export const MASK_GRADIENT_OPACITY_BOTTOM = 0.5

export const OUTLINE_TRANSITION_DURATION = 450

/**
 * Overlay fade. Leaving is quicker than arriving: the exit runs while the
 * review modal is already coming up, so the oval should be out of the way
 * rather than dissolving underneath it.
 */
export const OVAL_VISIBILITY_IN_DURATION = 300
export const OVAL_VISIBILITY_OUT_DURATION = 180

export type OutlineStateStyle = {
  color: string
  width: number
  /** Dash and gap lengths in screen pixels; omit for a solid stroke. */
  dash?: readonly [number, number]
}

export const OUTLINE_STATE_STYLES = {
  initial: { color: colors.white, width: 12, dash: [48, 24] },
  warning: { color: colors.amber[400], width: 8, dash: [48, 24] },
  scanning: { color: colors.cyan, width: 8 },
  completed: { color: colors.emerald, width: 8 },
} as const satisfies Record<OvalState, OutlineStateStyle>
